/* eslint-disable react/prop-types */
/* eslint-disable radix */
/* eslint-disable prefer-const */
import React from 'react';

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@mui/material';

import { ConfigCard } from '../../../../shared/components/ConfigCard';
import { CustomCardContent } from '../DevolutionPreferences/styles';

export default function Categories({
  categories,
  setCategory,
}) {
  return (
    <ConfigCard
      title="Categorias"
      subtitle="Selecione as categorias válidas para devolução"
      justifyContent="flex-start"
      flexWrap="wrap"
    >
      {categories &&
        categories.map((category, index) => {
          return (
            <CustomCardContent>
              <FormGroup
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <FormControlLabel
                  key={index}
                  control={<Checkbox checked={category.eligible} />}
                  label={category.name}
                  value={index}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </FormGroup>
            </CustomCardContent>
          );
        })}
    </ConfigCard>
  );
}
